import { Link } from "wouter";
import { fmt } from "../App/fmt";
import { href } from "../App/href";
import type { Product } from "../client";
import { button } from "../common.css";
import {
  DialogContent,
  DialogHeader,
  ScrollableDialog,
} from "../Dialog/Dialog";
import { accountNeeded } from "./ShopPage.css.ts";

export function AccountNeededDialog(props: {
  products: Product[];
  backTo: string;
  redirectTo: string;
}) {
  const { products, backTo, redirectTo } = props;
  const mentionUnlocks = products.some((p) => !!p.unlocks?.length);
  const productsCount = products.length;

  return (
    <ScrollableDialog isNarrow>
      <DialogHeader heading="Almost there!" />

      <DialogContent>
        <p className={accountNeeded.info}>
          We need an account to associate with your purchase, so that you can
          always get the{" "}
          <em>
            latest version of{" "}
            {fmt.plural(productsCount, {
              one: "this product",
              other: "these products",
            })}
          </em>
          {mentionUnlocks ? (
            <>
              {" "}
              and automatically unlock <em>in-app features</em>.
            </>
          ) : (
            "."
          )}
        </p>

        <div className={accountNeeded.actions}>
          <Link
            href={href("~/join", { search: { redirectTo, backTo } })}
            className={button()}
          >
            Join
          </Link>

          <Link
            href={href("~/login", { search: { redirectTo, backTo } })}
            className={button()}
          >
            Log in
          </Link>
        </div>
      </DialogContent>
    </ScrollableDialog>
  );
}
